import { render } from "./AdminDomainProviders.vue?vue&type=template&id=0df323be&scoped=true"
import script from "./AdminDomainProviders.vue?vue&type=script&lang=js"
export * from "./AdminDomainProviders.vue?vue&type=script&lang=js"

import "./AdminDomainProviders.vue?vue&type=style&index=0&id=0df323be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df323be"]])

export default __exports__